import React from "react";
import { useLang } from "../i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <section
      data-testid="marquee-section"
      aria-hidden
      className="border-y border-[#E5E5E5] bg-[#0A0A0A] text-[#F7F7F9] overflow-hidden py-5"
    >
      <div className="flex gap-14 whitespace-nowrap animate-marquee font-display text-2xl md:text-3xl tracking-tight">
        {items.map((word, i) => (
          <span key={i} className="inline-flex items-center gap-14">
            <span>{word}</span>
            <span className="text-[#D35400]">◆</span>
          </span>
        ))}
      </div>
    </section>
  );
}
